import { render } from "./requested_information_update.html?vue&type=template&id=4372d2b8&external"
import script from "./requested_information_update.js?vue&type=script&lang=js&external"
export * from "./requested_information_update.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__